import { Box , Theme, styled } from "@mui/material";

const DrawerHeaderStyled = styled(Box , { shouldForwardProp: (prop) => prop !== 'open' })(({ theme , open }:{theme:Theme , open:boolean}) => ({
    ...theme.mixins.toolbar,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: theme.spacing(open ? 3 : 0) , 
    paddingRight: theme.spacing(open ? 3 : 0)
}));

export default DrawerHeaderStyled;